<script setup lang="ts">
const aiResults = ref([])

const generateAiText = () => {
  aiResults.value = ['foobar 1', 'foobar 2', 'foobar 3']
}
</script>

<template>
  <div
    class="flex items-center h-full rounded-xl font-size-xs"
    @click="generateAiText"
  >
    <div class="grid grid-cols-2 gap-2">
      <div class="col-span-1">
        <Button type="button" variant="orange" icon="i-mdi:wizard-hat">
          Generate AI Text
        </Button>
      </div>
      <div class="col-span-1">
        <table v-if="aiResults.length" class="table-auto">
          <tbody>
            <tr>
              <td>Fotel Kolorio 82x71 cm</td>
              <td>
                <Button
                  type="button"
                  variant="primary"
                  icon="i-icon-park-outline:magic-wand"
                  size="small"
                />
              </td>
            </tr>
            <tr>
              <td>Fotel Pyszczek 82x71 cm</td>
              <td>
                <Button
                  type="button"
                  variant="primary"
                  icon="i-icon-park-outline:magic-wand"
                  size="small"
                />
              </td>
            </tr>
            <tr>
              <td>Fotel Fantazja 82x71 cm</td>
              <td>
                <Button
                  type="button"
                  variant="primary"
                  icon="i-icon-park-outline:magic-wand"
                  size="small"
                />
              </td>
            </tr>
            <tr>
              <td>Fotel Wesoły 82x71 cm</td>
              <td>
                <Button
                  type="button"
                  variant="primary"
                  icon="i-icon-park-outline:magic-wand"
                  size="small"
                />
              </td>
            </tr>
            <tr>
              <td>Fotel Zaskoczenie 82x71 cm</td>
              <td>
                <Button
                  type="button"
                  variant="primary"
                  icon="i-icon-park-outline:magic-wand"
                  size="small"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
